import { render, staticRenderFns } from "./RelatorioCargaHorariaAulasPraticasPorAluno.vue?vue&type=template&id=5d2c8614"
import script from "./RelatorioCargaHorariaAulasPraticasPorAluno.vue?vue&type=script&lang=js"
export * from "./RelatorioCargaHorariaAulasPraticasPorAluno.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports